import { render, staticRenderFns } from "./OrdersForCollection.vue?vue&type=template&id=1105e8e9&scoped=true"
import script from "./OrdersForCollection.vue?vue&type=script&lang=js"
export * from "./OrdersForCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1105e8e9",
  null
  
)

export default component.exports